window.customFormatMoney = function(cents) { 
  if (cents === null || cents === undefined) return '';
  if (typeof cents === 'string') cents = parseInt(cents);
  if (isNaN(cents)) return '';
  
  const amount = cents / 100;
  
  const currency = window.Shopify?.currency?.active || window.currencyConfig?.currency || 'USD';
  const locale = window.currencyConfig?.shopLocale || navigator.language || 'en-US';
  
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  } catch (error) {
    console.warn('Currency formatting failed, using fallback', error);
    return fallbackFormat(amount, currency);
  }
};

function fallbackFormat(amount, currency) {
  const locale = window.currencyConfig?.shopLocale || navigator.language || 'en-US';
  const formatted = amount.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  
  const symbols = {
    'USD': '$', 'EUR': '€', 'GBP': '£', 'JPY': '¥',
    'CAD': 'CA$', 'AUD': 'A$', 'CHF': 'CHF', 'CNY': '¥',
  };
  
  const symbol = symbols[currency] || currency;
  return symbol + formatted;
}
